import i18next from 'i18next';

i18next.addResources('en', 'AdelphiProductionMenu', {
  title: 'Production Menu',
  production: 'Production',
  spiritAttainment: 'Spirit Attainment',
  reporting: 'Reporting',
  administration: 'Administration'
});
